import { track_ga } from '../firebase'
import { fb_track } from '@/utils/fb-pixel'

// 自动填写游戏账号
export const autoInputUid = (gameName) => {
  track_ga('page_input_auto', { page: gameName })
}

// 游戏账号手动输入成功
export const inputUidManual = (gameName) => {
  track_ga('page_input_manual', { page: gameName })
}

// 输入id验证失败
export const inputUidFail = (gameName, error_code = -1) => {
  track_ga('page_input_fail', { page: gameName, error_code })
}

// 输入id验证成功
export const inputUidSuccess = (gameName) => {
  track_ga('page_input_success', { page: gameName })
}

// 点击“?”查看如何找到uid
export const inputTips = (gameName) => {
  track_ga('page_input_tip', { page: gameName })
}

// 套餐选择
const bundleIds = []
export const bundleChoose = (gameName, id) => {
  if (bundleIds.length === 0) {
    track_ga('page_bundle_group', { page: gameName }) // 只触发一次
    bundleIds.push(id)
  }
  // 每次都触发
  track_ga('page_bundle_times', { page: gameName })
}
// 支付方式选择
const paymentIds = []
export const paymentChoose = (gameName, id) => {
  if (paymentIds.length === 0) {
    track_ga('page_payment_group', { page: gameName }) // 只触发一次
    paymentIds.push(id)
  }
  // 每次都触发
  track_ga('page_payment_times', { page: gameName })
}

// 点击下单按钮
// 点击按钮即触发，无论是否登录、服务端是否返回信息
export const pageOrder = (params = {}) => {
  track_ga('page_order', params)
}

// 点击下单按钮
// 点击按钮即触发，无论是否登录、服务端是否返回信息
export const pageOrderFail = (params = {}) => {
  track_ga('page_order_fail', params)
}

// 生成订单，开始结账流程
export const beginCheckout = (params = {}) => {
  track_ga('begin_checkout', params)
}

// 自动输入id验证成功
export const inputUidAutoSuccess = (gameName) => {
  track_ga('page_input_autosuccess', { page: gameName })
}

// 选择服务器
export const trackSelectServer = (gameName, cp_server_id) => {
  track_ga('page_server_click', { page: gameName, cp_server_id })
}

// 点击套餐tip图标“?”
export const trackClickBundleTip = (gameName) => {
  track_ga('page_bundle_tip_click', { page: gameName })
}

// 检查订单
export const order_check = (gameName) => {
  track_ga('order_check', { page: gameName })
}

// 点击米大师（去兑换）
export const midas_redeem = (gameName) => {
  track_ga('midas_redeem', { page: gameName })
}

// 详情页 - 优惠展开
export function pageCouponClick(params = {}) {
  track_ga('page_coupon_click', params)
}

// pubgm点击优惠勾选处
export const pageDiscountChoose = (gameName) => {
  track_ga('page_discount_choose', { page: gameName })
}

export function pageClick() {
  if (!process.client) return
  function pageClick() {
    fb_track()
    window.removeEventListener('click', pageClick)
  }
  window.addEventListener('click', pageClick, false)
}

// ru pubgm 积赞活动: 活动弹窗曝光
export const likeActivityPopupShow = (page) => {
  track_ga('page_popup_show', { page })
}

// ru pubgm 积赞活动: 按钮点击
export const likeActivityPopupClick = (page) => {
  track_ga('page_popup_click', { page })
}

// 钱包交互触发后三种弹窗时guide;recharge;active；recharge_kgold(充值弹窗）;consume（支付弹窗）
export const walletRechargePopup = (page, popup_type) => {
  track_ga('recharge_popup', { page, popup_type })
}

// 钱包交互三种弹窗的按钮点击guide;recharge;active
export const walletRechargePopupClick = (page, popup_type) => {
  track_ga('recharge_popup_click', { page, popup_type })
}

//  下载按钮点击埋点
export const gameDownloadClick = (page, download_way) => {
  track_ga('game_download', { page, download_way })
}

// msa 收起窗口点击	点击
export const pageFoldClick = (page) => {
  track_ga('page_fold', { page })
}

// msa 点击跳转去下单页面	点击	选完套餐和支付方式，点击跳转按钮即触发
export const placeOrderClick = ({ page, sku_id, payment_name }) => {
  track_ga('place_order', { page, sku_id, payment_name })
}

// 「客户端好评弹层」 弹层曝光
export const gp_review_dialog_show = () => {
  track_ga('gp_review_dialog_show')
}
// 「客户端好评弹层」 点击好评
export const gp_review_click = () => {
  track_ga('gp_review_click')
}
